import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Error } from 'components/organisms'
import { Text } from 'components/atoms'
import styled from 'styled-components/macro'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // eslint-disable-next-line no-console
    console.error(error, errorInfo);
  }

  render() {
    const { hasError } = this.state
    const {
      children, code, message, helper
    } = this.props

    // You can render any custom fallback UI
    if (hasError) {
      return (
        <ErrorWrapper>
          <Error code={code} message={message} helper={helper} />
        </ErrorWrapper>
      )
    }

    return children;
  }
}

const ErrorWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-10%);
`;

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  message: PropTypes.string,
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  helper: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}

ErrorBoundary.defaultProps = {
  message: 'Algo correu mal.',
  code: 'Erro',
  helper: <Text modifiers="xs">Contacte o UA LAbs com este URL ou recarregue a página.</Text>,
}

export default ErrorBoundary
